import React from 'react'

const ShippingPolicy = () => {
    return (
        <div>
            <h2 className="font-bold text-xl mb-4">Shipping Policy</h2>
            <p>
                We are committed to delivering your orders quickly and securely. Orders are processed within 1-2 business days and shipped via our trusted courier partners. Estimated delivery time ranges from 3-7 business days depending on your location.
            </p>
            <p>
                Shipping charges, if applicable, will be displayed at checkout. Free shipping may be offered during promotions or above certain order values. International shipping availability may vary, and customers are responsible for any customs duties or taxes.
            </p>
            <p>
                We are not responsible for delays caused by unforeseen circumstances such as natural disasters, strikes, or courier service disruptions. Tracking details will be shared once your order is shipped.
            </p>
            <p>
                Please ensure accurate shipping details are provided. Incorrect or incomplete addresses may lead to delays or order cancellation.
            </p>
        </div>

    )
}

export default ShippingPolicy